import { getArticleLargeCardBody } from '@entities/articles/helpers.tsx';
import { memo, useCallback, useLayoutEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useArticleLargeCarPagedRedirect } from '@pages/articles/articlePage/helpers.ts';
import { ArticleDropMenu } from '@features/articles/article-card/menu/index.ts';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { ModerationStatusViewer } from '@features/common/SmallCardStatus/ModerationStatus/index.tsx';
import { useUser } from '@shared/hooks/index.ts';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { ListBody, PageHead } from '@shared/ui/index.ts';
import { CommentsSmallButton } from '@shared/ui/likes_comments/CommentsSmallButton/index.tsx';
import { LikesSmallButton } from '@shared/ui/likes_comments/LikesSmallButton/index.tsx';
import { useArticleQuery } from '@src/api/api-hooks/articles/useArticleQuery.ts';
import { useLikeArticleMutation } from '@src/api/api-hooks/articles/useLikeArticleMutation.ts';
import { useRemoveArticleLikeMutation } from '@src/api/api-hooks/articles/useRemoveArticleLikeMutation.ts';

type PT = {};
export const ArticlePage = memo(({}: PT) => {
  const { articleId } = useParams();
  const { code } = useModuleByCodeParam();
  const { user } = useUser();

  const { doRedirectOnPrevPage } = useArticleLargeCarPagedRedirect();

  const { data: articleData, isLoading: isArticleLoading } = useArticleQuery({ id: articleId });

  const { mutateAsync: like } = useLikeArticleMutation();
  const { mutateAsync: removeLike } = useRemoveArticleLikeMutation();

  const isAuthor = useMemo(() => articleData?.author.id === user?.id, [articleData, user]);

  const onClosePage = useCallback(
    () => doRedirectOnPrevPage(`/articles/${code}`),
    [doRedirectOnPrevPage, code]
  );

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const Body = useMemo(
    () => getArticleLargeCardBody({ isArticleLoading, articleData }),
    [isArticleLoading, articleData]
  );

  return (
    <>
      <PageHead
        Left={<PageBackButton onClick={onClosePage} />}
        Right={
          <>
            {articleData && isAuthor && (
              <ModerationStatusViewer
                isPublished={articleData.publication?.is_published || false}
                moderationStatus={articleData.moderation_status}
              />
            )}
            {articleData && articleData?.with_likes && (
              <LikesSmallButton
                isLiked={articleData.liked}
                likesCount={articleData.likes}
                onLike={() => like({ id: String(articleData.id) })}
                onRemoveLike={() => removeLike({ id: String(articleData.id) })}
              />
            )}
            {articleData && articleData?.with_comments && (
              <CommentsSmallButton count={articleData.comments.length} />
            )}
            {articleData && (
              <ArticleDropMenu
                isFavorite={articleData.favorite}
                id={Number(articleId)}
                isAuthor={isAuthor}
                authorId={articleData?.author?.coach?.id}
                isLargeCardDropdown={true}
              />
            )}
          </>
        }
        Center={'Статья'}
      />
      <ListBody>{Body}</ListBody>
    </>
  );
});
